module.exports = __webpack_public_path__ + "static/img/switch-1.91b657b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/detailpic/UC3880/switch-1.jpg
// module id = gwsU
// module chunks = 51